var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAureconLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 146.6 52.8",
    style: {
      enableBackground: "new 0 0 146.6 52.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7AB800;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,12.4c0,3.6,0,4.9-1.5,6.4c-1.1,1.1-3.1,1.4-4.5,0.9c-0.5-0.2-0.9-0.4-1.3-0.8C5,17.5,5.1,15,6.6,13.6 c1.9-1.8,4.4-1.7,7.1-1.7L13.7,12.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.3,39c1.6,0.9,4,1.5,6.1,1.4l0-18.9h-6.6l0,12.5c-1.1,0.8-2.6,1.3-3.8,1.3c-1.6,0-1.9-0.8-2-2.4V21.5h-6.6 v11.4v1c0,2.1,0.5,3.8,1.6,5.1c1.1,1.2,2.8,1.9,5,1.9C36.2,40.9,38.3,40.3,40.3,39z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.7,22.9c-1.6-0.9-4-1.5-6.1-1.4v18.9h6.6l0-12.5c0.9-0.8,2.6-1.4,4.9-1.3l1.3-5.5 C59,20.8,56.4,22.4,55.7,22.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.1,21c-6.6,0-10.5,4.3-10.5,9.9c0,2.9,0.8,5.4,2.5,7.2c1.7,1.8,4.3,2.9,7.7,2.9c6.6,0,10.5-4.3,10.5-9.9 c0-2.9-0.8-5.4-2.5-7.2C118.1,22,115.5,21,112.1,21z M111.9,35.9c-2.7,0-3.5-2.3-3.5-5c0-2.7,0.9-4.9,3.6-4.9c2.7,0,3.5,2.2,3.5,5 C115.5,33.7,114.6,35.9,111.9,35.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.4,22.9c-1.6-0.9-4-1.5-6.1-1.4v18.9h6.6l0-12.5c1.1-0.8,2.6-1.3,3.8-1.3c1.6,0,1.9,0.8,2,2.4v11.4h6.6 V28.9v-1c0-2.1-0.5-3.8-1.6-5.1c-1.1-1.2-2.8-1.9-5-1.9C134.5,20.9,132.4,21.6,130.4,22.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.1,35.9c-2.2,0-4.2-1.1-4.8-3.1h12.6v-1.9c0-2.7-0.4-5.4-2.5-7.4c-1.5-1.6-3.8-2.5-6.4-2.5 c-6.3,0-10.7,4-10.7,10c0,3.1,1,5.6,2.9,7.3c1.9,1.7,4.6,2.7,7.8,2.7c3.7,0,6.6-0.9,8.7-1.7l-1.4-4.4C77.5,35.6,75.4,35.9,74.1,35.9 z M72.6,25.9c1.8,0,2.7,1.3,2.8,2.7h-6C69.8,27.1,70.9,25.9,72.6,25.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.9,35.9c-2.6,0-4.2-1.7-4.2-5c0-3.2,1.5-4.9,4.5-4.9c1,0,2.3,0.2,4.7,1.1l1.1-4.8c0,0-2.8-1.4-6.6-1.4 c-3.3,0-5.9,1-7.7,2.8c-1.8,1.8-2.8,4.4-2.8,7.5c0,3,1,5.5,2.7,7.1c1.8,1.7,4.3,2.5,7.4,2.5h0c2.1,0,4.2-0.2,7.3-1.6 c-0.3-0.8-1.1-3.5-1.5-4.6C98.3,35.4,96.6,36,94.9,35.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.9,40.4c-1.7-1.9-1.9-4.6-1.9-6.6l0-12.3h-8.7c-3.6,0-6.8,1-9.2,3.3c-1.8,1.7-2.8,4.1-2.8,6.5 c0,0.4,0,0.5,0,0.5c0,2.6,1,5,2.8,6.8c1.8,1.7,4.2,2.5,6.7,2.5h0.6c2.1,0,4.2-0.5,6.4-2C21.5,39.9,23.9,40.4,25.9,40.4L25.9,40.4z  M16.9,34c-1.1,1.1-3.1,1.4-4.5,0.9c-0.5-0.2-0.9-0.4-1.3-0.8c-1.5-1.4-1.3-3.9,0.2-5.4c1.9-1.8,4.4-1.7,7.1-1.7l0,0.5 C18.4,31.3,18.4,32.6,16.9,34z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAureconLogoWhite);
export default __webpack_public_path__ + "static/media/aurecon_logo_white.d83c250d4925dc680d44e2b918353b2d.svg";
export { ForwardRef as ReactComponent };